export const orderBy = <T,>(arr: T[], props: (keyof T)[], orders?: ('asc' | 'desc')[]) =>
    [...arr].sort((a, b) =>
        props.reduce((acc, prop, i) => {
            if (acc === 0) {
                const [p1, p2] = orders && orders[i] === 'desc' ? [b[prop], a[prop]] : [a[prop], b[prop]];
                acc = p1 > p2 ? 1 : p1 < p2 ? -1 : 0;
            }
            return acc;
        }, 0),
    );

function delay(ms: number): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function withRetry<Args extends unknown[], R>(
    fn: (...args: Args) => Promise<R>,
    options?: {
        maxRetries?: number;
        baseDelay?: number;
        shouldRetry?: (error: unknown, attempt: number) => boolean;
    },
): (...args: Args) => Promise<R> {
    const maxRetries = options?.maxRetries ?? 10;
    const baseDelay = options?.baseDelay ?? 500;
    const shouldRetry = options?.shouldRetry ?? (() => true);

    return async (...args: Args): Promise<R> => {
        let attempt = 0;

        while (attempt < maxRetries) {
            try {
                return await fn(...args);
            } catch (error) {
                attempt++;
                if (attempt >= maxRetries || !shouldRetry(error, attempt)) {
                    throw error;
                }
                const delayTime = baseDelay * Math.pow(2, attempt);
                await delay(delayTime);
            }
        }

        return fn(...args);
    };
}
